import axios from '@/utils/request'
var Qs = require('qs')

export default {
  // 2020-08-14
  findByTenantId() {
    return axios.get('/suppliers/find-by-tenant-id')
  },
  // 2022-05-19
  findNoHiddenByTenantId() {
    return axios.get('/suppliers/find-no-hidden-by-tenant-id')
  },
  // 2020-10-17
  findByPhone(params) {
    return axios.get('/suppliers/find-by-phone', params)
  },
  // 2020-10-17
  search(params) {
    return axios.get('/suppliers', params)
  },
  // 2020-10-17
  create(params) {
    return axios.post('/suppliers', params)
  },
  // 2020-10-17
  update(id, params) {
    return axios.put('/suppliers/' + id, params)
  },
  // 2020-10-17
  updateFlags(params) {
    return axios.put('/suppliers/update-flags', params)
  },
  // 2020-10-17
  delete(id) {
    return axios.delete('/suppliers/' + id)
  },
  // 2020-10-17 
  exportExcel(params) {
    return axios.get('/suppliers/export-excel?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
  },
  // 2020-10-17
  vagueFindByName(params) {
    return axios.get('/suppliers/vague-find-by-name', params)
  },
  // 2021-09-11
  vagueFindByPhoneOrName(params) {
    return axios.get('/suppliers/vague-find-by-phone-or-name', params)
  },


  // 2021-01-18
  swapSequence(params) {
    return axios.put('/suppliers/swap-sequence', params)
  },
  // 2021-03-31
  findBySequence(params) {
    return axios.get('/suppliers/find-by-sequence', params)
  },

  // 2022-03-10
  calcCapacity(params) {
    return axios.put('/suppliers/calc-capacity', params)
  },
  // 2020-10-17
  findById(id) {
    return axios.get('/suppliers/' + id)
  }

}

